/* global jQuery */

// jQuery ready fires after GF has initialised its forms.
jQuery(() => {
	document.querySelectorAll('.gform_wrapper').forEach((el) => {
		const form_id = el.id.replace('gform_wrapper_', '');
		process_form(el, form_id);
		set_next_icon(el);

		// Re-run whenever GF swaps the form HTML (AJAX page navigation)
		const observer = new MutationObserver(() => {
			process_form(el, form_id);
			set_next_icon(el);
		});
		observer.observe(el, { childList: true, subtree: true });
	});
});

function process_form(el, form_id) {
	const steps_div = el.querySelector(`#gf_page_steps_${form_id}`);
	if (steps_div) steps_div.style.display = 'none';

	const pages = [...el.querySelectorAll('.gform_page')];
	const total = pages.length;
	if (total <= 1) return;

	// Current page = the one that isn't hidden
	const current_index = pages.findIndex(
		(p) => getComputedStyle(p).display !== 'none'
	);
	if (current_index === -1) return;
	const page = current_index + 1;

	// Insert into the VISIBLE page's footer (each page has its own footer)
	const footer = pages[current_index].querySelector('.gform-page-footer');
	if (!footer) return;

	const text = `${page} / ${total}`;
	const existing = footer.querySelector('.subscribe_step_count');
	if (existing && existing.textContent === text) return; // avoid observer loop
	if (existing) existing.remove();

	const counter = document.createElement('span');
	counter.className = 'subscribe_step_count';
	counter.textContent = text;
	footer.insertBefore(counter, footer.firstChild);
}

// Banner only: replace the "Next" button label with an icomoon glyph (\e91a)
function set_next_icon(el) {
	if (!el.closest('.subscribe_form')) return;
	el.querySelectorAll('.gform_next_button').forEach((btn) => {
		if (btn.dataset.iconified) return;
		btn.value = '\ue91a'; // icomoon glyph (\e91a)
		btn.classList.add('has_next_icon');
		btn.dataset.iconified = '1';
	});
}
